/**
 * Checks whether or not a feature is enabled for the current environment
*/
const hasFeature = (feature) => process.env[`REACT_APP_FEATURE_${feature}`] === 'true';

export default hasFeature;